import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Accordion, AccordionDetails, Box, Grid, CircularProgress, Backdrop } from "@mui/material";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import NoRecordFound from "src/components/NoRecordFound";
import Heading from "./Heading";
import { MonthlyFrequency } from "./MonthlyFrequency";
import { useStyles } from "./styles";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export default function Recur({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [recurInfo, setRecurInfo] = useState({});
  const { ordNum } = useParams<{ ordNum: any }>();

  const getIVRData = async () => {
    try {
      setLoader(true);
      const results = await fetchWrapper.get(`get-recur-master-summary-by-ord-num/${ordNum}`);
      setRecurInfo(results);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  React.useEffect(() => {
    if (expand) {
      getIVRData();
    }
  }, [expand]);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(1)}>
          <Heading heading="Recur Info" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Grid container direction="row">
              <Grid xs={12} md={12}>
                <MonthlyFrequency data={recurInfo} />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}
